import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Welcome from '../../../components/layout/Welcome';
import { activateViewEnter } from '../actions';
import CaptureCardNumber from '../CaptureCardNumber';
import CapturePhoneNumber from '../CapturePhoneNumber';
import { STEP_CARD_NUMBER, STEP_LANDING, STEP_PHONE_NUMBER, STEP_SUCCESS } from '../constants';
import Landing from '../Landing';
import { getStep } from '../selectors';
import Success from '../Success';

export class Activate extends Component {
  componentWillMount() {
    this.props.viewEnter();
  }

  render() {
    const { step } = this.props;

    if (step === STEP_LANDING) {
      return (<Landing />);
    }
    if (step === STEP_CARD_NUMBER) {
      return (<Welcome><CaptureCardNumber /></Welcome>);
    }
    if (step === STEP_PHONE_NUMBER) {
      return (<Welcome><CapturePhoneNumber /></Welcome>);
    }
    if (step === STEP_SUCCESS) {
      return (<Welcome><Success /></Welcome>);
    }
    return null;
  }
}

Activate.propTypes = {
  viewEnter: PropTypes.func.isRequired,
  step: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  step: getStep(state)
});

const mapDispatchToProps = {
  viewEnter: activateViewEnter
};

export default connect(mapStateToProps, mapDispatchToProps)(Activate);
